import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, message, Card } from 'antd';
import { useAuthStore } from '../stores/authStore';
import axios from 'axios';

// 配置axios基础URL，指向后端服务
axios.defaults.baseURL = (typeof window !== 'undefined' ? window.location.protocol + '//' + window.location.host : '') + '/api';
const WeChatCallback = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleWeChatLogin } = useAuthStore();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (!code) {
          message.error('微信登录失败：缺少授权码');
          navigate('/login');
          return;
        }

        // 调用后端微信登录回调API（axios.baseURL 已含 /api，这里不能再带 /api，否则变成 /api/api 404）
        const response = await axios.get(`/auth/wechat/callback?code=${code}&state=${state}`);
        
        if (response.data.success) {
          const { token, user } = response.data;
          
          // 使用store处理登录
          const result = await handleWeChatLogin({ token, user });
          
          if (result.success) {
            message.success(response.data.message);
            
            // 管理员与普通用户一致，统一进首页
            setTimeout(() => {
              navigate('/');
            }, 1000);
          } else {
            message.error('微信登录处理失败');
            navigate('/login');
          }
        } else {
          message.error(response.data.message || '微信登录失败');
          navigate('/login');
        }
      } catch (error) {
        console.error('微信登录回调处理失败:', error);
        message.error('微信登录失败，请重试');
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, navigate, handleWeChatLogin]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Card style={{ textAlign: 'center', padding: '40px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
          正在处理微信登录...
        </div>
      </Card>
    </div>
  );
};

export default WeChatCallback;
